import React from "react";
import {
  ButtonBase,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  CardContent,
  Card,
  LinearProgress,
} from "@material-ui/core";
import Download from "@material-ui/icons/CloudDownload";
import { CloudUpload } from "@material-ui/icons";
import { useMeetingAppContext } from "../../MeetingAppContextDef";
import "../mainViewContainer/style.css";
// import CardContent from '@mui/material/CardContent';
const VB = [
  "dubai",
  "argentina",
  "austria",
  "brazil",
  "bulgaria",
  "cambodia",
  "egypt",
  "germany",
  "india",
  "korea",
  "romania",
  "slovakia",
  "spain",
  "tailand",
  "taiwan",
  "turky",
];
const VisualBackgroundList = ({ panelHeight }) => {
  const { changeVisual, setChangeVisual } = useMeetingAppContext();
  return (
    <List style={{ padding: 10, overflow: "scroll", height: "90%" }}>
      <p style={{ color: "white" }}>Change Background</p>
      {VB?.map((i) => {
        return (
          <Card
            variant="outlined"
            style={{ height: 100, width: "100%", marginBottom: 10 }}
            onClick={()=>{
                setChangeVisual(i)
            }}
          >
            <CardContent
              style={{ height: 100, width: "100%" }}
              className={i}
            ></CardContent>
          </Card>
        );
      })}

      {/* {[
        {
          Icon: PollIcon,
          primary: "Create Poll",
          secondary:
            "Ask participants their opinion on a subject - Coming Soon.",
          disabled: true,
          onClick: () => {},
        },
        {
          Icon: GestureIcon,
          primary: "White board",
          secondary: "White board - Coming Soon.",
          disabled: true,
          onClick: () => {},
        },
      ].map(({ Icon, primary, secondary, disabled, onClick }, i) => (
        <ButtonBase
          disabled={disabled}
          onClick={onClick}
          style={{
            alignItems: undefined,
            justifyContent: undefined,
            width: "100%",
          }}
        >
          <ListItem key={`activities_panel_item_${i}`}>
            <ListItemAvatar>
              <Avatar>
                <Icon color={"primary"} />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={primary} secondary={secondary} />
          </ListItem>
        </ButtonBase>
      ))} */}
    </List>
  );
};

export default VisualBackgroundList;
